/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTracking from 'base/components/standalone/Tracking';

export const DynamicStandaloneTracking = StandaloneTracking;
export type DynamicStandaloneTrackingProps = PropsFromComponent<typeof StandaloneTracking>;

export const DynamicStandaloneTrackingWith = (extras: DynamicStandaloneExtras): typeof StandaloneTracking => {
    return function DynamicStandaloneTracking(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Tracking');
        return <StandaloneTracking {...mergeProps({ options: { theme } }, props)} />;
    }
}